/* eslint-disable react/jsx-pascal-case */
import { useState, useEffect } from 'react'
import clientes from '../../../api/clientes'
import * as S from '../styles'
import * as mask from '../masks'
import { useDispatch } from 'react-redux'
import { setUserAddress, setUserInfo } from '../../../store/ducks/user'
import defaultOptions from '../../../api/defaultoption'

const Step1 = ({
  userData,
  alterarSenha,
  alterarEmail,
  editarDados,
  onChange,
  subAtividade,
  setSubAtividade
}) => {
  const [atividades, setAtividades] = useState([])
  const [funcionarios, setFuncionarios] = useState([])
  const [cargos, setCargos] = useState([])
  const [departamentos, setDepartamentos] = useState([])

  const dispatch = useDispatch()

  const apiCall = async () => {
    let cargos = await clientes.cargos()
    let departamentos = await clientes.departamentos()
    let atividades = await clientes.atividades()
    let funcionarios = await clientes.funcionarios()
    cargos = await cargos.json()
    setCargos(cargos)
    atividades = await atividades.json()
    setAtividades(atividades)
    funcionarios = await funcionarios.json()
    setFuncionarios(funcionarios)
    departamentos = await departamentos.json()
    setDepartamentos(departamentos)
  }

  const fetchSubAtividade = async (idAtividade) => {
    if (idAtividade === '') return []
    let req = await clientes.subAtividades(idAtividade)
    req = await req.json()
    setSubAtividade(req)
  }

  useEffect(() => {
    apiCall()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // setLoading(true)
    if (userData.idAtividade) fetchSubAtividade(userData.idAtividade)
  }, [userData.idAtividade])

  useEffect(() => {
    dispatch(setUserInfo(userData))
  }, [userData])

  // console.log(userData)

  async function getAddress() {
    // setLoading(true)
    await clientes
      .enderecos(defaultOptions)
      .then((response) => {
        // setLoading(false)
        return response.json()
      })
      .then((obj) => dispatch(setUserAddress(obj)))
      .catch((err) => {
        // if (err) setLoading(false)
      })
  }

  useEffect(() => {
    getAddress()
  }, [])

  return (
    <div>
      {/* {loading ? <Loader /> : null} */}
      <S.WrapperExibition>
        <S.col_group>
          <S.col12>
            <S.form_group>
              <S.label>E-mail</S.label>
              {userData.email}
            </S.form_group>
          </S.col12>

          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>Contato</S.label>
                {userData.contato}
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Departamento</S.label>
                {
                  departamentos?.filter(
                    (e) => e.departamentoId === userData.idDepartamento
                  )[0]?.departamento
                }
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Cargo</S.label>
                {
                  cargos?.filter((e) => e.cargoId === userData.idCargo)[0]
                    ?.cargo
                }
              </S.form_group>
            </S.col4>
          </S.box>

          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>Razão Social</S.label>
                {userData.razaoSocial}
              </S.form_group>
            </S.col4>
            {/*
            <S.col4>
              <S.form_group>
                <S.label>Nome Fantasia</S.label>
                {userData.nomeFantasia}
              </S.form_group>
            </S.col4>
            */}
            <S.col4>
              <S.form_group>
                <S.label>CNPJ</S.label>
                {mask.cnpjMask(userData.cnpj)}
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Inscrição Estadual</S.label>
                {userData.inscricaoEstadual === ('ISENTO' || '')
                  ? 'ISENTO'
                  : userData.inscricaoEstadual}
              </S.form_group>
            </S.col4>
          </S.box>
          <S.box>
            {/*
            <S.col4>
              <S.form_group>
                <S.label>Inscrição Municipal</S.label>
                {userData.inscricaoMunicipal}
              </S.form_group>
            </S.col4> */}
            {/*
            <S.col4>
              <S.form_group>
                <S.label>Data de Abertura</S.label>
                {mask.dateFromString(userData.dataAbertura)}
              </S.form_group>
            </S.col4>*/}
          </S.box>

          <S.box>
            {' '}
            {/*
            <S.col4>
              <S.form_group>
                <S.label>Ramo de Atividade</S.label>
                {
                  atividades?.filter(
                    (e) => e.atividadeId === userData.idAtividade
                  )[0]?.atividade
                }
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Sub-Atividade</S.label>
                {
                  subAtividade?.filter(
                    (e) => e.subAtividadeId === userData.idSubAtividade
                  )[0]?.subAtividade
                }
              </S.form_group>
            </S.col4>
          </S.box>

          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>Funcionários Adm.</S.label>
                {
                  funcionarios?.filter(
                    (e) =>
                      e.porteId === userData.numeroFuncionariosAdministrativos
                  )[0]?.porte
                }
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Total Funcionários</S.label>
                {
                  funcionarios?.filter(
                    (e) => e.porteId === userData.numeroFuncionariosTotal
                  )[0]?.porte
                }
              </S.form_group>
            </S.col4> */}
          </S.box>

          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>Telefone Celular</S.label>
                {mask.cellMask(
                  userData.telefoneCelularDDD + userData.telefoneCelularNumero
                )}
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Telefone Comercial</S.label>
                {mask.fixPhoneMask(
                  userData.telefoneComercialDDD +
                    userData.telefoneComercialNumero
                )}
              </S.form_group>
            </S.col4>
            {userData.telefoneComercialRamal !== null && (
              <S.col4>
                <S.form_group>
                  <S.label>Ramal</S.label>
                  {userData.telefoneComercialRamal}
                </S.form_group>
              </S.col4>
            )}
          </S.box>

          <S.perfilBoxFooter>
            <S.button onClick={() => alterarSenha()}>Alterar Senha</S.button>
            <S.button onClick={() => alterarEmail()}>Alterar E-mail</S.button>
            <S.button onClick={() => editarDados()}>Editar Dados</S.button>
          </S.perfilBoxFooter>
        </S.col_group>
      </S.WrapperExibition>
    </div>
  )
}

export default Step1
